function alert(message, timeout) {
  var alertDiv = constructMessageNode(message);
  document.body.appendChild(alertDiv);
  setTimeout(() => {
    document.body.removeChild(alertDiv);
  }, timeout);
}

function constructMessageNode(message) {
  let alertDiv = document.createElement('div');
  alertDiv.setAttribute('role', 'alert');
  alertDiv.classList.add('u-audible');
  alertDiv.appendChild(document.createTextNode(message));
  return alertDiv;
}

export default {
  alert
}
